import { styled } from "@linaria/react";

import AvatarShimmer from "@gx/dls/avatar/AvatarShimmer";
import FlexWrapper, { AlignItems, JustifyContent } from "@gx/dls/containers/FlexWrapper";
import TextShimmer from "@gx/dls/text/TextShimmer";
import { withTheme } from "@gx/dls/theme";
import { PropsWithTheme } from "@gx/dls/theme/types";

const SelectProjectSourceCardWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.color.background.primary};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
`);

const SelectProjectSourceCardLoading = () => {
  return (
    <SelectProjectSourceCardWrapper>
      <FlexWrapper
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.SPACE_BETWEEN}
        fillWidth
        padding="12px 16px"
      >
        <FlexWrapper alignItems={AlignItems.CENTER} gap={16}>
          <TextShimmer height={20} width={20} />
          <AvatarShimmer size={28} />
          <TextShimmer height={20} width={128} />
        </FlexWrapper>
        <FlexWrapper alignItems={AlignItems.CENTER} gap={16}>
          <TextShimmer height={16} width={120} />
          <TextShimmer height={8} width={8} />
        </FlexWrapper>
      </FlexWrapper>
    </SelectProjectSourceCardWrapper>
  );
};

export default SelectProjectSourceCardLoading;
